import { fetchPurchaseQuotes, selectPurchaseQuote, resetCurrentPurchaseQuote, deletePurchaseQuote} from '../../actions/purchaseQuotes_actions';
import {fetchPurchaseOrderList} from '../../actions/purchaseOrders_actions';
import { connect } from 'react-redux';

import PurchaseQuoteList from '../../components/Purchase/purchaseQuoteList'

function mapStateToProps(state) {
    return {
        currentPurchaseQuote: state.purchaseQuotes.currentPurchaseQuote,
        purchaseQuotes: state.purchaseQuotes.all,
        isLoading: state.purchaseQuotes.isLoading,
        error: state.purchaseQuotes.error,
        userPermissions: state.auth.userPermissions,
        currentPurchaseQuote: state.purchaseQuotes.currentPurchaseQuote,
        purchaseOrderList: state.purchaseOrders.purchaseOrderList,
        purchaseOrderListIsLoading: state.purchaseOrders.purchaseOrderListIsLoading,
        purchaseOrderListError: state.purchaseOrders.purchaseOrderListError,
        purchaseQuoteIsDeleting: state.purchaseQuotes.purchaseQuoteIsDeleting,
        purchaseQuoteDeleteError: state.purchaseQuotes.purchaseQuoteDeleteError,
        purchaseQuoteIsDeleted: state.purchaseQuotes.purchaseQuoteIsDeleted
    };
}

export default connect(mapStateToProps, { fetchPurchaseQuotes, selectPurchaseQuote, resetCurrentPurchaseQuote, fetchPurchaseOrderList, deletePurchaseQuote })(PurchaseQuoteList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseQuoteList.jsx